import * as types from '../mutation-types'

// state
export const state = {
  navItems: [],
  secondaryNavItems: [],
  standaloneNavItems: [],
  apoOneNavItems: []
}

// getters
export const getters = {
  navItems: state => state.navItems,
  secondaryNavItems: state => state.secondaryNavItems,
  standaloneNavItems: state => state.standaloneNavItems,
  apoOneNavItems: state => state.apoOneNavItems
}

// mutations
export const mutations = {
  [types.SET_NAV_ITEMS](state, {navItems}) {
    state.navItems = navItems
  },
  [types.SET_SECONDARY_NAV_ITEMS](state, {secondaryNavItems}) {
    state.secondaryNavItems = secondaryNavItems
  },
  [types.SET_STANDALONE_NAV_ITEMS](state, {standaloneNavItems}) {
    state.standaloneNavItems = standaloneNavItems
  },
  [types.SET_APO_ONE_NAV_ITEMS](state, {apoOneNavItems}) {
    state.apoOneNavItems = apoOneNavItems
  }
}

// actions
export const actions = {
  setNavItems({commit, dispatch}, {navItems}) {
    commit(types.SET_NAV_ITEMS, {navItems})
  },
  setSecondaryNavItems({commit, dispatch}, {secondaryNavItems}) {
    commit(types.SET_SECONDARY_NAV_ITEMS, {secondaryNavItems})
  },
  setStandaloneNavItems({commit, dispatch}, {standaloneNavItems}) {
    commit(types.SET_STANDALONE_NAV_ITEMS, {standaloneNavItems})
  },
  setApoOneNavItems({commit, dispatch}, {apoOneNavItems}) {
    commit(types.SET_APO_ONE_NAV_ITEMS, {apoOneNavItems})
  }
}
